import { CartogramLegendSettings } from '@project/components/Module/Cartograms';
import { LegendsSettingsFormInstance } from '@project/components/Module/Cartograms/components/CartogramMapLegend';
import { FormInstance } from 'antd';
import { action, makeObservable, observable } from 'mobx';

export class LegendsSettingsStore {
  form?: FormInstance<LegendsSettingsFormInstance> = undefined;
  @observable settings: CartogramLegendSettings[] = [];

  constructor() {
    makeObservable(this);
  }

  @action setSettings = (settings: CartogramLegendSettings[]) => {
    this.settings = settings;
  };

  setForm = (formInstance?: FormInstance<LegendsSettingsFormInstance>) => {
    this.form = formInstance;
  };

  @action reset = () => {
    this.form?.resetFields();
    this.settings = [];
  };
}
